export enum JobState {
  Pending = 'pending',
  Running = 'running',
  Failed = 'failed',
  Complete = 'complete',
  Cancelled = 'cancelled',
}
